var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIparqueHorizontalColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 270.9 71.8",
    style: {
      enableBackground: "new 0 0 270.9 71.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st5{fill:#001531;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    d: "M47.7,1.2L47.7,1.2l-46.2,0v0H1.2v69.4H15l0,0h13.9V56.7H15V15.1h27.8v27.8H28.9v13.9h27.7V1.2 L47.7,1.2z",
    fill: "#0651F1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    transform: "translate(69.39 23.701)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1",
    x: 1.2,
    y: 2.2,
    className: "st5",
    width: 6.5,
    height: 30.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    className: "st5",
    d: "M36.6,3.3c-2.4-1.4-5.1-2.2-7.9-2.1c-2.1,0-4.3,0.5-6.2,1.5c-0.9,0.5-1.8,1.1-2.6,1.8V2.2 h-6.5v43.1h6.5V30.7c2.4,2.2,5.6,3.4,8.9,3.4c2.8,0,5.5-0.7,7.9-2.1c2.3-1.4,4.2-3.4,5.4-5.9c2.6-5.3,2.6-11.5,0-16.9 C40.8,6.8,38.9,4.8,36.6,3.3z M28.8,28c-1.6,0-3.2-0.4-4.6-1.3c-1.4-0.9-2.5-2.1-3.2-3.6c-1.6-3.4-1.6-7.4,0-10.8 c0.7-1.5,1.8-2.7,3.2-3.6c1.4-0.9,3-1.3,4.6-1.3c1.6,0,3.2,0.4,4.5,1.3c1.4,0.9,2.4,2.2,3.1,3.6c0.8,1.7,1.2,3.6,1.2,5.5 c0,1.9-0.4,3.7-1.2,5.4l0,0c-0.7,1.5-1.8,2.7-3.1,3.6C31.9,27.6,30.4,28,28.8,28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    className: "st5",
    d: "M71.9,4.6c-2.4-2.2-5.6-3.4-8.9-3.4c-2.8,0-5.5,0.7-7.9,2.1c-2.3,1.4-4.2,3.4-5.4,5.9 c-2.6,5.3-2.6,11.5,0,16.9c1.3,2.4,3.2,4.5,5.5,5.9c2.4,1.4,5.1,2.2,7.9,2.1c2.1,0,4.3-0.5,6.2-1.5c0.9-0.5,1.8-1.1,2.6-1.8v2.4 h6.5V2.2h-6.5L71.9,4.6z M70.7,12.2c1.6,3.4,1.6,7.4,0,10.8l0,0c-0.7,1.5-1.8,2.7-3.2,3.6c-1.4,0.9-3,1.3-4.6,1.3 c-1.6,0-3.2-0.4-4.5-1.3c-1.4-0.9-2.4-2.2-3.1-3.6c-0.8-1.7-1.2-3.6-1.2-5.5c0-1.9,0.4-3.7,1.2-5.4c0.7-1.5,1.8-2.7,3.1-3.6 c1.3-0.9,2.9-1.3,4.5-1.3c1.6,0,3.2,0.4,4.6,1.3C69,9.5,70,10.8,70.7,12.2L70.7,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    className: "st5",
    d: "M103.3,2l-0.8-0.3c-1-0.3-2.1-0.5-3.2-0.5c-2.3,0-4.5,0.7-6.4,2c-0.9,0.6-1.7,1.3-2.4,2.1V2.2 h-6.5v30.9h6.5V18.3c-0.1-2.1,0.4-4.2,1.3-6.1c0.7-1.5,1.8-2.8,3.2-3.8c1.3-0.8,2.7-1.3,4.3-1.3c0.8,0,1.6,0.2,2.3,0.5l1.7,0.8 L103.3,2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    className: "st5",
    d: "M127.4,4.6c-0.8-0.7-1.7-1.3-2.6-1.8c-1.9-1-4-1.5-6.2-1.5c-2.8,0-5.5,0.7-7.9,2.1 c-2.3,1.4-4.2,3.5-5.5,5.9c-2.6,5.3-2.6,11.5,0,16.9c1.2,2.4,3.1,4.4,5.4,5.9c2.4,1.4,5.1,2.2,7.9,2.1c3.3,0,6.5-1.2,8.9-3.4v14.6 h6.5V2.2h-6.5V4.6z M126.3,12.2c1.6,3.4,1.6,7.4,0,10.8c-0.7,1.5-1.8,2.7-3.2,3.6c-1.4,0.9-3,1.3-4.6,1.3c-1.6,0-3.2-0.4-4.5-1.3 c-1.4-0.9-2.4-2.1-3.1-3.6c-0.8-1.7-1.2-3.5-1.2-5.4c0-1.9,0.4-3.8,1.2-5.5c0.7-1.5,1.8-2.7,3.1-3.6c1.3-0.9,2.9-1.3,4.5-1.3 c1.6,0,3.2,0.4,4.6,1.3C124.5,9.5,125.6,10.8,126.3,12.2L126.3,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    className: "st5",
    d: "M160.2,17.7c0.1,2.7-0.5,5.4-2,7.7c-1.3,1.8-3.4,2.8-5.7,2.6c-4.4,0-6.4-2.3-6.4-7.3V2.2h-6.5 v20.3c0,2.2,0.5,4.4,1.7,6.2c1.1,1.7,2.7,3.1,4.5,4c1.9,0.9,3.9,1.4,6,1.3c2.2,0,4.3-0.5,6.2-1.7c0.8-0.5,1.5-1,2.1-1.7v2.4h6.5 V2.2h-6.5L160.2,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7",
    className: "st5",
    d: "M198.4,8.9c-1.2-2.3-3.1-4.2-5.3-5.6c-2.3-1.4-4.9-2.1-7.6-2.1c-2.8,0-5.5,0.7-7.9,2.1 c-2.3,1.4-4.2,3.5-5.4,5.9c-1.3,2.6-2,5.5-1.9,8.4c0,2.9,0.6,5.8,2,8.4c1.3,2.4,3.2,4.5,5.5,5.9c2.4,1.4,5.2,2.2,8,2.1 c0.6,0,1.2,0,1.7-0.1l1.1-0.1v-6.1l-1.3,0.1c-0.5,0.1-1.1,0.1-1.6,0.1c-2.4,0.1-4.7-0.9-6.3-2.7c-1.4-1.6-2.2-2.6-2.5-4.4h23.3 l0.1-1c0-0.5,0.1-2.6,0.1-3.1C200.3,14,199.7,11.3,198.4,8.9z M177.2,15.4c0.4-2,1.1-4.5,2.6-5.8c3.2-2.9,8.1-3,11.5-0.3 c1.6,1.4,2.1,3.7,2.4,6.1H177.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIparqueHorizontalColored);
export default __webpack_public_path__ + "static/media/iparque-horizontal-colored.7528fb415e82d2fb3a23773643063f55.svg";
export { ForwardRef as ReactComponent };